export default "__VITE_ASSET__f4454073__"